import React, { Component } from 'react';
import { connect } from 'react-redux'
import {Row,Col} from 'react-bootstrap'
import {addToCart,handleDetails} from '../../actions/cart_Action'
import styled from 'styled-components'
import {Modal} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import {ButtonContainer} from '../Button/Button'

 class Data extends Component{
  state = {
    loading: false
  };

  fetchData = (key) => {
    this.setState({ loading: true });

    //Faking API call here
    this.handleDelete(key)
    setTimeout(() => {
      this.setState({ loading: false });
    }, 4000);
  
  };

  

  handleDetails=(key)=>{
    this.props.handleDetails(key); 
  }
  handleDelete=(key)=>{

    this.props.eosio3.deleteItemData(key)
    
  }

    render(){
      const { loading } = this.state;
      let itemList = this.props.inititems.map(item=>{
       if(item.owner ===localStorage.getItem("account_name"))
         
            return(
        <> 
        
              
            <Col sm={4} className="card_complete">
            <ProductWrapper>               
             <div className="card custom-border" key={item.key}>
                
                        <div className="d-block w-100 img-container">
                         {/* <Link to='/upload2'> */}
                            <img src={item.img} className="img-fluid card-img-top" alt=" not found" style={{ width: "50rem", height: "12rem" }}
                            
                            onClick ={()=>{
                                    
                              this.handleDetails(item.key)             
                              }}
                            />
                           {/* </Link>  */}
                              
                         </div>
 {/* <Link to ='/upload2'> */}
                    <div className="card-body" 
                        onClick ={()=>{
                                    
                  //        this.handleDetails(item.key)             
                          }}
                    >
               
                <h4 className="card-title">
                  {item.p_name}     
                </h4>
                <h5>{item.price}</h5>
                <p className="card-text">{item.info}</p>
                <Link to ='/upload2'>
                <ButtonContainer
                     onClick ={()=>{
                                    
                      this.handleDetails(item.key)             
                      }}
                  
                >Edit Item</ButtonContainer></Link>
                
                <ButtonContainer
                   onClick ={()=>{
                                    
                    this.fetchData(item.key)             
                    }}
                    disabled={loading}>
                    {loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    {loading && <span>Loading... </span>}
                    {!loading && <span>Delete Item</span>}</ButtonContainer>
        
              </div>
              <div className="card-footer">
                <small className="text-muted">★ ★ ★ ★ ☆</small>
              </div>
 {/* </Link>               */}
                 </div>

                 </ProductWrapper>
                 </Col>
       
      </>           
            )
        })
      
        return(
            
            <div className="container">
                <h3 className="center">Our items</h3>

                <Row>
              
                    {itemList}
               
                </Row>
            </div>
            
        )
        
    }
}
const mapStateToProps = (state)=>{
    
    return {
      //items: state.items,
      inititems:state.inititems
    }
  }

  const mapDispatchToProps= (dispatch)=>{
    
    return{
//        addToCart: (key)=>{dispatch(addToCart(key))},
        handleDetails: (key)=>{dispatch(handleDetails(key))},
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Data)

const ProductWrapper=styled.div`

&:hover{
    .card{
      border:0.04rem solid rgba(0,0,0,0.2);
      box-shadow:2px 2px 5px 0px rgba(0,0,0,0.2)
    }
    .card-footer{
      background:rgba(247,247,247);
    }
  }
  
.img-container{
    position:relative;
    overflow:hidden;
  }
  .card-img-top{
    transition:all 1s linear;
  }
  .img-container:hover .card-img-top{
    transform:scale(1.2);
  }
  
  
`;
